import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var UpdateImageAssetsAction = function () {

}


UpdateImageAssetsAction.prototype = {

    updateImageAssets: function (data) {

        restClient.updateImageAssets(data, function (error, response) {
            if (response != null) {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_IMAGE_ASSETS,
                    data: response
                });
            } else if (error && error.status === 401) {
                AppDispatcher.dispatch({
                    actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                    data: error
                });
            } else {
                // A real network failure (offline, timeout, CORS block) leaves
                // both error and response empty here - without this branch,
                // nothing would dispatch and the caller's error toast/loader
                // would never fire.
                AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_IMAGE_ASSETS,
                    data: error || { data: { message: 'Network error - please try again' } }
                });
            }
        })
    }
}

export default new UpdateImageAssetsAction();